export const LOCALES = {
  ENGLISH: 'en',
  SPANISH: 'es',
};
